module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/le-palais-montcalm.json
// module id = 603
// module chunks = 219332963808097